"use client"

import { useLingui } from "@lingui/react/macro"
import { ItemMedia } from "../../item/view/item-media"

interface Props {
  imageSrc?: string
  nftName: string
}

export function NftPreviewImage(props: Props) {
  const { t } = useLingui()

  return (
    <ItemMedia
      src={props.imageSrc}
      alt={t`Image for ${props.nftName} item`}
      className="rounded-md object-contain"
    />
  )
}
